export default {"src":"/_next/static/media/pencil.d4f50524.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};